<template>
  <div>
    <div v-if="showPage">
      <section class="wrapper">
        <calendar ref="calendarD" @change="changeHandler" @chooseDate="chooseDate">
          <template slot="append" slot-scope="item" v-if="getData(item.date)">
            <div class="point" :style="`background-color:${getData(item.date).color}`"></div>
          </template>
        </calendar>
        <div class="container">
          <div class="sumBody" v-if="showList.length">
            <div @click="stopCander" v-for="(item,index) in showList" :key="index" :class="{'disable':item.listColor}">
            <span>
              <span style="display: block">{{item.meetStart}}</span>
              <span style="display: block">{{item.meetEnd}}</span>
            </span>
              <ul :id="`${item.date}`">
                <li :style="`--color:${item.listColor}`">
                  <span class="sumDetail">{{item.activityTitle}}</span>
                  <div>
                    <button @click.stop="detailHandler(item.emsGuid)">详情</button>
                    <button  @click.stop="joinHandler(item.attendMeetingUrl)" v-if="item.color!=='#DBDBDB'">参会</button>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
    <!--<div v-if="showGuide" class="guideTofollow"></div>-->
    <div v-if="showGuide" class="guideTofollowImg">
      <img src="../../assets/guide_background_prod.png" />
    </div>
    <agreeBookDialog :ABDialogShow="ABDialogShow" :openId="openId" @ABDialogShowFn="ABDialogShowFn"></agreeBookDialog>
  </div>
</template>

<script>
import calendar from "../myComponents/calendar";
import agreeBookDialog from "./agreeBookDialog";
export default {
  data() {
    return {
      showPage: false,
      ABDialogShow:false,
      baseUrl: process.env.config.baseUrl,
      openId: localStorage.openId,
      MeetingList: [],
      showList:[],
      items: {},
      showGuide: false
    };
  },
  components: { calendar,agreeBookDialog },
  created() {
    this._colors = ["#0BA0E6", "#EA2323", "#DBDBDB"];

  },
  mounted () {
    console.log(process.env.config.seviceUrl, 'process.env.config.seviceUrl')
    if (process.env.config.seviceUrl.indexOf('wechatweb.takeda.com.cn') > -1) {
      document.title = '吾医空间'
    } else {
      document.title = '吾医空间测试号'
    }
    if (!localStorage.openId) {
      // process.env.config.baseUrl
      // window.location.host
      let url = process.env.config.baseUrl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/meetingList?returnurl=' + encodeURIComponent((this.oriUrl || '')))
      // this.$axiox.get(url).then(msg => {
      //   console.log(msg)
      // })
      window.location.href = url
    } else {
      this.openId = localStorage.openId
      let data = {
        openId: this.openId,
        returnurl: encodeURIComponent(window.location.href),
        docCode: ''
      }
      this.$axiox.postNoRes(process.env.config.baseUrl + '/api/wechat/getdoctorstatus', data).then(p => {
        if (p.data.status === 2 || p.data.status === 3) {
          let data2 = {
            openId: this.openId,
            returnurl: encodeURIComponent(window.location.href)
          }
          this.$axiox.postNoRes(process.env.config.baseUrl + '/api/wechat/getEmployee', data2).then(p2 => {
            if (p2.data.status === 2 || p2.data.status === 3) {

              if(this.NewerTag=='NoHcp'){

this.$commonJs.mobileDoubleComfirm({
buttonType: "0",
type: "warning",
title: "提示",
content:
  "该平台仅供医疗卫生专业人士（HCP）使用，您已注册非HCP，暂无权限！",
successFun: () => {
},
errorFun: (err) => {},
});

}
              //window.location.href = ('//' + window.location.host + '/register?returnurl=' + encodeURIComponent(window.location.href))
            }
            this.showPage = true
            this.$nextTick(p => {
              this.$refs.calendarD.show = true
              this.$refs.calendarD._notify()
            })
          })
        }
      })
      // let isEmployee = window.localStorage.getItem('isEmployee')
      // let requestUrl = ''
      // if (isEmployee) {
      //   requestUrl = '/api/wechat/getEmployee/'
      // } else {
      //   requestUrl = '/api/wechat/getDoctor/'
      // }
      // this.$axiox.getNoRes(process.env.config.baseUrl + requestUrl + this.openId + '?returnurl=' + encodeURIComponent(this.returnurl)).then(msg => {
      //   if (msg.isSuccess) {
      //     if (msg.data.status === 2) {
      //       // window.location.href = 'https://' + window.location.host + '/register?returnurl=' + encodeURIComponent((window.location.href || ''))
      //     }
      //     else if (msg.data.status === 3) {
      //       // window.location.href = 'https://' + window.location.host + '/register?returnurl=' + encodeURIComponent((window.location.href || ''))
      //     } else {
      //       if (msg.data.isFollowed) {
      //         this.showPage = true
      //         this.$refs.calendarD.show = true
      //         this.$refs.calendarD._notify()
      //       } else {
      //         // this.$commonJs.closeWindow()
      //         this.showGuide = true
      //       }
      //     }
      //   }
      // })
    }

    setTimeout(() => {
    this.getSignDetail();
    }, 1000);

  },
  computed: {},
  methods: {
     getSignDetail() {
      let data = {
        openid: this.openId,
        docCode: "",
      };
      this.$axiox.postNoRes("/api/hcp/getHcpSignDetail", data).then((p) => {
        if (p.data == "True") {
         if(this.showGuide!=true){
          //name: "agreeBook",
          this.ABDialogShow = true
          }
        } else if (p.data == "False") {
        } //无需重新签署
        else {
        } //返回值错误
      });
    },
    ABDialogShowFn() {
      this.ABDialogShow =false;
    },
    stopCander () {
      // this.$refs.calendarD.show = false
    },
    getData(date) {
      var key = date.format("yyyyMMdd");
      if (this.items[key] == undefined) {
        return false;
      }
      return this.items[key];
    },
    changeHandler(date, start, end) {
      var _start = this.formateDate(start);
      var _end = this.formateDate(end);
      this.MeetingList.splice(0, this.MeetingList.length);
      var now = new Date(new Date().setHours(0, 0, 0, 0));
      var nowDate=now.format("yyyyMMdd");
      this.$axiox.getNoRes(`/api/hcp/GetCalendarMeetings?openid=${this.openId}&startDate=${_start}&endDate=${_end}`).then(rsp => {
        var dict={};
        rsp.data.map(item=>{
          var date=item.startDate.split(/\s/)[0];
          if(!dict[date]){
            dict[date]=item.isAttend;
          }
        });
        rsp.data.map(item => {
        if (item.startDate) {
          if (now > new Date(item.startDate.replace(/-/g, "/"))) {
            item.color = this._colors[2];
            // 列表颜色
            item.listColor=this._colors[2];
          } else {
            let key=item.startDate.split(/\s/)[0];
            let isAttend=dict[key];
            let index = isAttend ? 1 : 0;
            item.color = this._colors[index];
             // 列表颜色
            let listInx=item.isAttend?1:0;
            item.listColor=this._colors[listInx];
          }
        } else {
            let key=item.startDate.split(/\s/)[0];
            let isAttend=dict[key];
            let index = isAttend ? 1 : 0;
            item.color = this._colors[index];
        }
        if (item.startDate) {
          item.meetStart = new Date(item.startDate.replace(/-/g, "/"))
            .toLocaleTimeString("en-US")
            .replace(/:[0-9][0-9](\s)/, " ");
        } else {
          item.meetStart = ''
        }
        if (item.endDate) {
          item.meetEnd = new Date(item.endDate.replace(/-/g, "/"))
            .toLocaleTimeString("en-US")
            .replace(/:[0-9][0-9](\s)/, " ");
        } else {
          item.meetEnd = ''
        }
        if (item.startDate) {
          item.date = item.startDate.substring(0, 10).replace(/-/g, "");
        } else {
          item.date = ''
        }

        this.$set(this.items, item.date, item);
      });
        this.MeetingList.push(...rsp.data);
        this.showList=this.MeetingList.filter(item=>item.date==nowDate);

      })
    },
    formateDate(date) {
      var year = date.getFullYear();
      var month = (date.getMonth() + 1).toString();
      var day = date.getDate().toString();
      if (month.length == 1) {
        month = "0" + month;
      }
      if (day.length == 1) {
        day = "0" + day;
      }
      var dateTime = year + "-" + month + "-" + day;
      return dateTime;
    },
    chooseDate(item){
      let newList = this.MeetingList.filter((it)=>{
        return it.date==item.dateId;
      });
      let newListAttend = newList.filter((it)=>{
        return it.isAttend;
      });
      let newListNoAttend = newList.filter((it)=>{
        return !it.isAttend;
      });
      newListAttend.sort( (a, b) => {
        if (a.startDate && b.startDate) {
          if (new Date(a.startDate.replace(/-/g, '/')).getTime() < new Date(b.startDate.replace(/-/g, '/')).getTime()) {
            return -1;
          } else if ((a.id || 0) === (b.id || 0)) {
            return 0;
          } else {
            return 1;
          }
        }
      });
      newListNoAttend.sort( (a, b) => {
        if (a.startDate && b.startDate) {
          if (new Date(a.startDate.replace(/-/g, '/')).getTime() < new Date(b.startDate.replace(/-/g, '/')).getTime()) {
            return -1;
          } else if ((a.id || 0) === (b.id || 0)) {
            return 0;
          } else {
            return 1;
          }
        }
      });
      this.showList = newListAttend.concat(newListNoAttend)
    },
    detailHandler(guid){
      this.$router.push({name:'meetingDetail',params:{id:guid}});
    },
    joinHandler(url){
      if (url) {
        window.location.href = url
      } else {
        this.$commonJs.showTips('暂无参会链接')
      }
    }
  }

};
</script>

<style lang="less" scoped>
.wrapper {
  *:not(.iconfont) {
    font-family: 'source' !important;
  }
  background: #fff;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  height: 100vh;
  .calendar {
    z-index: 500;
    background-color: white;
    box-shadow: 0 4px 5px -3px #e1e1e1;
    .point {
      height: 5px;
      width: 5px;
      border-radius: 50%;
      background-color: red;
      align-self: center;
    }
  }
  .container {
    padding-top: 10px;
    z-index: 100;
    flex: 1;
    overflow-y: scroll;
    &::-webkit-scrollbar-thumb {
       -webkit-box-shadow: inset 0 0 5px !important;
      background:white !important;
      color:#ccc;
    }
    &::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 5px white !important;
       background: white !important;
    }
    .sumBody {
      > div {
        position: relative;
        > span {
          vertical-align: middle;
          display: inline-block;
          width: 33%;
          margin-left: 2%;
          padding: 5px 0;
          text-align: center;
          border-radius: 5px;
          border: 1px solid #f3f3fb;
          font-size: 1.2em;
          box-shadow: 0 4px 5px -3px #e1e1e1;
        }

        > ul {
          display: inline-block;
          width: 55%;
          vertical-align: middle;
          padding: 0 12px;
          list-style: none;
          > li {
            &::before {
              content: "";
              border-left: 2px solid #ddd;
              position: absolute;
              width: 10px;
              height: 100%;
              top: 0;
              left: -20px;
            }
            padding: 10px 4%;
            border-radius: 5px;
            border-left: 10px solid var(--color);
            border-top: 1px solid #e7e7e7;
            border-right: 1px solid #e7e7e7;
            border-bottom: 1px solid #e7e7e7;
            background-color: white;
            position: relative;
            margin-bottom: 4%;
            &::after {
              content: "";
              display: inline-block;
              width: 12px;
              height: 12px;
              border-radius: 100%;
              background-color: var(--color);
              position: absolute;
              top: 50%;
              left: -25px;
            }
            > span {
              font-size: 1em;
            }
            > div {
              height: 40px;
              display: flex;
              margin-top: 10px;
              justify-content: flex-end;
              align-items: center;
              > button {
                border-radius: 5px;
                padding: 0 0.6rem;
                height: 30px;
                margin-left: 20px;
                letter-spacing: 2px;
                background-color: var(--color);
                border: 2px solid var(--color);
                color: white;
              }
              & > button:first-child {
                background-color: white;
                color: black;
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/meetingList.vue